import { createSlice } from '@reduxjs/toolkit';

interface timeworkSlice {
  timework: {
    id: string;
    time?: Array<{ day: string, open: Array<string>, enable: boolean }>;
    messageOfficeHour?: string,
    messageOutsideOfficeHour?: string
  };
}

const initialState: timeworkSlice = {
  timework: {
    id: '',
    time: [
      {
        day: "Sunday",
        open: ['08:00', '17:00'],
        enable: false,
      },
      {
        day: "Monday",
        open: ['08:00', '17:00'],
        enable: true,
      },
      {
        day: "Tuesday",
        open: ['08:00', '17:00'],
        enable: true,
      },
      {
        day: "Wednesday",
        open: ['08:00', '14:00'],
        enable: true,
      },
      {
        day: "Thursday",
        open: ['08:00', '17:00'],
        enable: true,
      },
      {
        day: "Friday",
        open: ['08:00', '17:00'],
        enable: true,
      },
      {
        day: "Saturday",
        open: ['08:00', '17:00'],
        enable: true,
      },
    ],
    messageOfficeHour: '',
    messageOutsideOfficeHour: ''
  },
};

export const timeworkSlice = createSlice({
  name: 'timework',
  initialState,
  reducers: {
    selectTimework: (state, { payload }) => {
      state.timework = { ...payload, header: {} };
    },
    resetTimework: (state) => {
      state.timework = initialState.timework;
    },
    setTimework: (state, action) => {
      state.timework = action.payload;
    },
    removeTimework: (state) => {
      state.timework = { id: '' };
    },
  },
});

export const { setTimework, removeTimework, resetTimework, selectTimework } =
  timeworkSlice.actions;

export default timeworkSlice.reducer;